module.exports = __webpack_public_path__ + "img/jcat-logo.fbdb4371.svg";